<template lang="pug">
.footer 
  slot
  span.counter {{ slideCounter }}
</template>

<script>
export default {
  methods: {
    slideshow() {
      let el = this;
      while (el && (!el.isSlideshow || el.inserted)) el = el.$parent;
      return el;
    },
  },
  computed: {
    slideCounter() {
      const slideshow = this.slideshow();
      return `${slideshow.currentSlideIndex - 1} / ${
        slideshow.slides.length - 2
      }`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '../style/ugent.scss' as ugent;

.footer {
  background: ugent.$blauw;
  color: ugent.$wit;
  padding: ugent.$small-pad ugent.$pad;
  font-size: 12px;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 400px;
  z-index: 30;

  .counter {
    position: absolute;
    right: ugent.$pad;
    bottom: ugent.$small-pad;
  }
}
</style>